import { FC } from "react";
import { Layer, Source } from "react-map-gl";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { store } from 'stores/Store';
interface MapRouteSourceAndLayersProps {
  id: string;
  type: "geojson";
  data?: GeoJSON.Feature<GeoJSON.LineString>;
}

export const MapRouteSourceAndLayers: FC<MapRouteSourceAndLayersProps> = ({
  id, type, data,
}) => {
  return (
    <Source
      id={id}
      type={type}
      data={data}>
      <Layer
        id="route-line"
        type="line"
        layout={{
          'line-join': 'round',
          'line-cap': 'round'
        }}
        paint={{
          'line-color': '#0066FF',
          'line-width': 4
        }}
      />
    </Source>

  )
}

interface MapRoutePinsSourceAndLayersProps {
  id: string;
  type: "geojson";
  data?: GeoJSON.FeatureCollection<GeoJSON.Point, { id: number }>;
}

export const MapRoutePinsSourceAndLayers: FC<MapRoutePinsSourceAndLayersProps> = ({
  id, type, data,
}) => {
  return (
    <Source
      id={id}
      type={type}
      data={data}>
      <Layer
        id="route-points"
        type="symbol"
        filter={[
          'all',
        ]}
        layout={{
          'text-field': [
            "number-format",
            ["+",
              ["index-of",
                ["get", "id"],
                ["literal", store?.selectedPractitioners
                  .map((s, index) => s.isFirstLocation || s.isLastLocation ? index + 1 : s.id) || []]],
              1,
            ],
            {},
          ],
          'icon-image': "custom-marker-route",
          'icon-size': 0.9,
          "icon-allow-overlap": true,
          'text-allow-overlap': true,
          // Text positioning - adjust these values to move the number
          'text-offset': [0, -0.2], // Moving text up by ~2px (0.1em is roughly 1.6px at 16px font size)
          'text-anchor': 'center', // Options: center, left, right, top, bottom, top-left, top-right, bottom-left, bottom-right
          // Font styling for better readability
          'text-font': ['DIN Offc Pro Bold', 'Arial Unicode MS Bold'], // Bold fonts
          'text-size': 16, // Increase size for better readability
        }}
        paint={{
          'text-color': '#000000', // Black text
          // Add text halo for better contrast
          'text-halo-color': '#FFFFFF', // White halo around black text
          'text-halo-width': 2, // Width of the halo
          'text-halo-blur': 1, // Slight blur for softer edge
        }}
      />
    </Source>
  );
}

// Separate component for selected pin overlay - renders on top of everything
interface SelectedPinOverlayProps {
  id: string;
  type: "geojson";
  data?: GeoJSON.FeatureCollection<GeoJSON.Point, {
    id: number, index: number
  }>;
  selectedPinIndex?: number;
}

export const SelectedPinOverlay: FC<SelectedPinOverlayProps> = ({
  id, type, data, selectedPinIndex
}) => {
  return (
    <Source
      id={`${id}-selected`}
      type={type}
      data={data}
    >
      {/* Selected pin - renders on top of all other layers */}
      <Layer
        id="selected-point"
        type="symbol"
        filter={[
          "all",
          ['!', ['has', 'point_count']],
          ['==', ['get', 'index'], (selectedPinIndex || 0)],
        ]}
        layout={{
          'icon-image': "selected-marker-green",
          'icon-size': .9,
          "icon-allow-overlap": true,
        }}
      />
    </Source>
  );
};
